//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import moment from 'moment-timezone';
import Vue from 'vue';
import EventCard from '../../molecules/event-card/event-card.vue';
import EventGrid from '../event-grid/event-grid.vue';
import InputDate from '../../molecules/input-date/input-date.vue';
import EqSelect from '../../atoms/eq-select/eq-select.vue';

export default {
  components: {
    'eq-select': EqSelect,
    'input-date': InputDate,
    'event-card': EventCard,
    'event-grid': EventGrid,
  },
  props: {
    eventOccurrences: Array,
    timezoneName: String,
    eventCategories: Array,
    startDate: Date,
  },
  watch: {
    occurrences(occ, oldOcc) {
      this.initOccurrences();
    },
  },
  data() {
    let data = {
      occurrences: this.$options.eventOccurrences || this.eventOccurrences || [],
      timezone: this.$options.timezoneName || this.timezoneName || moment.tz.guess(),
      categories: this.$options.eventCategories || this.eventCategories || [],
      category: this.$options.category || null,
      allWeeks: [],
      weeks: [],
      startPosition: 0,
    };

    data.date = moment(this.$options.startDate || this.startDate || undefined)
      .tz(data.timezone)
      .toDate();

    return data;
  },
  methods: {
    initOccurrences() {
      this.startPosition = 0;
      let allWeeks = this.occurrences.reduce((a, occurrence) => {
        let startWeek = this.getWeekStartInListTz(occurrence.start, occurrence.timezone);
        let endWeek = this.getWeekStartInListTz(occurrence.end, occurrence.timezone);
        let endWeekDate = endWeek.format('YYYY-MM-DD');
        let firstWeekStartDate = this.firstWeekStartDate();

        let weekIndex = 0, nextWeekStart, nextWeekStartDate;
        do {
          nextWeekStart = startWeek.clone().add(weekIndex++, 'week');
          nextWeekStartDate = nextWeekStart.format('YYYY-MM-DD');

          if (nextWeekStartDate >= firstWeekStartDate && nextWeekStartDate <= endWeekDate) {
            a[nextWeekStartDate] = a[nextWeekStartDate] || {
              events: [],
              startDay: nextWeekStart
            };
            a[nextWeekStartDate].events.push(occurrence);
          }
        } while (nextWeekStartDate <= endWeekDate);

        return a;
      }, {});

      // Calculate all weeks once and store.
      this.allWeeks = Object.keys(allWeeks).sort().map(timestamp => allWeeks[timestamp]);

      // Initial page. Only render the 1st week on page load.
      this.weeks = this.allWeeks.slice(this.startPosition, this.startPosition + 1);
    },
    scroll() {
      window.onscroll = () => {
        var scrollTop = document.documentElement.scrollTop;
        var innerHeight = window.innerHeight;
        var offsetHeight = document.documentElement.offsetHeight;

        // Used greater than or equal to offsetHeight in comparison because IE11
        // will always resolve scrollTop + innerHeight to offsetHeight + 1.
        var bottomOfWindow = scrollTop + innerHeight >= offsetHeight;
        if (bottomOfWindow) {
          this.showNextPage();
        }
      };
    },
    showNextPage() {
      this.startPosition++;
      var currentWeekPage = this.weeks;
      var nextWeekPage = this.allWeeks.slice(this.startPosition, this.startPosition + 1);
      if (nextWeekPage.length) {
        this.weeks.push(...nextWeekPage);
      }
    },
    getWeekStartInListTz(date, timezone) {
      let eventSunday = moment(date).tz(timezone).startOf('week');
      return this.convertToTz(eventSunday, this.timezone);
    },
    convertToTz(date, timezone) {
      return moment.tz(date.format('YYYY-MM-DDTHH:mm:ss'), timezone);
    },
    isThisWeek(start) {
      let end = start.clone().add(6, 'days');
      return (start <= this.now && this.now <= end);
    },
    isNextWeek(start) {
      let end = start.clone().add(6, 'days');
      let nextWeek = this.now.clone().add(7, 'days');
      return (start <= nextWeek && nextWeek <= end);
    },
    weekTitle(start) {
      if (this.isThisWeek(start)) {
        return 'This week';
      }
      if (this.isNextWeek(start)) {
        return 'Next week';
      }
      let end = start.clone().add(6, 'days');
      let startsThisYear = this.now.format('YYYY') == start.format('YYYY');

      if (start.format('YYYY') != end.format('YYYY')) {
        return start.format('MMMM D YYYY') + ' - ' + end.format('MMMM D YYYY');
      }
      else if (start.format('MMMM') != end.format('MMMM')) {
        return start.format('MMMM D')
          + ' - ' + end.format('MMMM D')
          + (!startsThisYear ? start.format(' YYYY') : '');
      }
      else {
        return start.format('MMMM D')
          + ' - ' + end.format('D')
          + (!startsThisYear ? start.format(' YYYY') : '');
      }
    },
    onInput() {
      this.$emit('input', {
        date: this.date,
        category: this.category,
      });
    },
    firstWeekStartDate() {
      return moment.tz(this.date, this.timezone)
        .startOf('week')
        .format('YYYY-MM-DD');
    },
  },
  mounted() {
    this.initOccurrences();
    this.scroll();
  },
  computed: {
    now() {
      return moment().tz(this.timezone);
    }
  }
}



// WEBPACK FOOTER //
// ./app/components/organisms/event-week-list/event-week-list.vue